import { useEffect, useMemo } from "react";
import { Plus, X } from "lucide-react";
import { Input } from "../ui/input";

export const TRYON_TYPES = [
  { id: "clothing", label: "Clothing" }, { id: "shoes", label: "Shoes" }, { id: "jewelry", label: "Jewelry" },
  { id: "wig", label: "Wigs/Hair" }, { id: "accessories", label: "Bag / hat / glasses" }, { id: "watch", label: "Watch" },
];

const Thumb = ({ file, onRemove, index }) => {
  const url = useMemo(() => URL.createObjectURL(file), [file]);
  useEffect(() => () => URL.revokeObjectURL(url), [url]);
  return (
    <div className="relative h-16 w-16 overflow-hidden rounded-lg border border-white/10">
      <img src={url} alt="" className="h-full w-full object-cover" />
      <button type="button" onClick={onRemove} data-testid={`second-item-remove-photo-${index}`}
        className="absolute right-0.5 top-0.5 rounded-full bg-black/70 p-0.5 text-white"><X className="h-3 w-3" /></button>
    </div>
  );
};

// Optional second try-on item worn together with the main product (e.g. a watch with the bag)
export const SecondItemPicker = ({ value, onChange }) => {
  if (!value) {
    return (
      <button type="button" onClick={() => onChange({ type: "watch", name: "", images: [] })} data-testid="add-second-item-btn"
        className="flex items-center gap-1.5 rounded-full border border-dashed border-pink-500/50 px-3 py-1.5 text-xs text-pink-300 hover:bg-pink-500/10 transition-colors">
        <Plus className="h-3.5 w-3.5" /> Add a second item to wear (e.g. a watch with the bag)
      </button>
    );
  }
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div data-testid="second-item-panel" className="space-y-2 rounded-lg border border-pink-500/30 bg-pink-500/5 p-3">
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium text-white">Second item (shown too, your main product stays the star)</p>
        <button type="button" onClick={() => onChange(null)} data-testid="remove-second-item-btn" className="text-white/50 hover:text-white">
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {TRYON_TYPES.map((t) => (
          <button key={t.id} type="button" onClick={() => set({ type: t.id })} data-testid={`second-item-type-${t.id}`}
            className={`rounded-full border px-2.5 py-1 text-xs transition-colors ${value.type === t.id ? "border-pink-500 bg-pink-500/20 text-white" : "border-white/10 text-white/60 hover:text-white"}`}>
            {t.label}
          </button>
        ))}
      </div>
      <Input data-testid="second-item-name-input" value={value.name} maxLength={80} placeholder="What is it? e.g. Gold steel watch"
        onChange={(e) => set({ name: e.target.value })} className="h-8 bg-white/5 border-white/10 text-sm" />
      <div className="flex flex-wrap gap-2">
        {value.images.map((f, i) => (
          <Thumb key={`${f.name}-${i}`} file={f} index={i} onRemove={() => set({ images: value.images.filter((_, j) => j !== i) })} />
        ))}
        {value.images.length < 3 && (
          <label data-testid="second-item-upload" className="flex h-16 w-16 cursor-pointer items-center justify-center rounded-lg border border-dashed border-white/20 text-white/50 hover:border-pink-500/60">
            <Plus className="h-5 w-5" />
            <input type="file" accept="image/*" multiple className="hidden" data-testid="second-item-file-input"
              onChange={(e) => { set({ images: [...value.images, ...Array.from(e.target.files || [])].slice(0, 3) }); e.target.value = ""; }} />
          </label>
        )}
      </div>
      {!value.images.length && <p className="text-[11px] text-amber-300/80">Add 1-3 photos of the second item, or remove it.</p>}
    </div>
  );
};
